import api from "./api";

function normalizeCollaborators(items) {
  if (!Array.isArray(items)) return [];

  return items.filter((collaborator) => collaborator && collaborator.id != null);
}

export async function fetchCollaboratorOptions() {
  try {
    const listboxResponse = await api.get("/collaborators/listbox");
    const listboxItems = normalizeCollaborators(listboxResponse.data);

    if (listboxItems.length > 0) {
      return listboxItems;
    }
  } catch (error) {
    console.warn("Falha ao carregar listbox de colaboradores, tentando fallback.", error);
  }

  try {
    const activeResponse = await api.get("/collaborators/", {
      params: { is_active: true, limit: 1000 },
    });
    const activeItems = normalizeCollaborators(activeResponse.data);

    if (activeItems.length > 0) {
      return activeItems;
    }
  } catch (error) {
    console.warn("Falha ao carregar colaboradores ativos, tentando lista completa.", error);
  }

  try {
    const allResponse = await api.get("/collaborators/", {
      params: { limit: 1000 },
    });
    const allItems = normalizeCollaborators(allResponse.data);

    return allItems.filter((collaborator) => collaborator.is_active !== false);
  } catch (error) {
    console.error("Erro ao carregar colaboradores para vinculacao de ativos:", error);
    return [];
  }
}
